import { useEffect, useState, useCallback } from "react";
import { SAVE_FAVORITE } from "../api/constants";

const STORAGE_KEY = "favoriteProperties";

export default function useFavoritesList() {
  const [favorites, setFavorites] = useState(new Set());
  const token = localStorage.getItem("token");

  useEffect(() => {
    const stored =
      JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    setFavorites(new Set(stored));
  }, []);

  const toggleFavorite = useCallback((propertyId) => {
    setFavorites((prev) => {
      const updated = new Set(prev);

      if (updated.has(propertyId)) {
        updated.delete(propertyId);
      } else {
        updated.add(propertyId);
      }

      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify([...updated])
      );

      return updated;
    });
  }, []);

  const isFavorite = useCallback(
    (propertyId) => favorites.has(propertyId),
    [favorites]
  );

  //  const saveFavorite= async () => {
  //       fetch(SAVE_FAVORITE, {
  //         method: "POST",
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //           "Content-Type": "application/json",
  //         },
  //         body: JSON.stringify({
  //           property_id: propertyId
  //         }),
  //       })
  //         .then((response) => {
  //           if (!response.ok) {
  //             throw new Error("Network response was not ok");
  //           }
  //           return response.json();
  //         })
  //         .then((data) => {
  //           console.log(data.data)
  //           if (data.data.saved) {
  //             setIsFavorite(true)
  //           } else {
  //            setIsFavorite(false)
  //           }
  //         })
  //         .catch((error) => {
  //           console.error("Error creating account:", error);
  //         });
      
  
  //   };

  return { favorites, isFavorite, toggleFavorite };
}
